import React, { useCallback, useMemo } from 'react';
import { FlatList, StyleSheet, } from 'react-native';
import { noop } from 'lodash';
import { rem, IconEdit, SettingsSection } from 'design-system';
import Button from 'design-system/Button';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useColors from 'hooks/useColors';
import { GroupExpenseCRowSelectable } from './GroupExpenseCRow';
const keyExtractor = (user) => user.id.toString();
const GroupTransactionSplit = ({ users, amountSplit, currency, paidBy, total, onSave, onSelect, splitType, disabled, isDefaultSplit, conversionRate, convertedCurrency, showTitle = true, style, ListHeaderComponent, }) => {
    const navigation = useMainStackNavigation();
    const selectedUsers = useMemo(() => Object.entries(amountSplit)
        .filter(([, share]) => Number(share) > 0)
        .map(([userId]) => Number(userId)), [amountSplit]);
    const renderItem = useCallback(({ item }) => {
        const selected = selectedUsers.includes(item.id);
        const balance = Number(amountSplit[item.id]) * (total > 0 ? 1 : -1);
        return (<GroupExpenseCRowSelectable disabled={disabled} selected={selected} groupUser={item} balance={balance} currency={currency} convertedBalance={conversionRate ? balance * conversionRate : undefined} convertedCurrency={convertedCurrency} onPress={disabled ? noop : onSelect}/>);
    }, [
        amountSplit,
        conversionRate,
        convertedCurrency,
        currency,
        disabled,
        onSelect,
        selectedUsers,
        total,
    ]);
    const colors = useColors();
    const ListFooterComponent = useMemo(() => (<Button square brandReversed title="Custom split" leftIcon={<IconEdit color={colors.text.textOnBrand} width={16} height={16}/>} containerStyle={styles.button} leftIconContainerStyle={styles.leftIcon} onPress={() => navigation.navigateDeprecated('GroupCustomSplit', {
            paidBy,
            split: amountSplit,
            splitType,
            total,
            currency,
            users,
            onSave,
            isDefaultSplit,
        })}/>), [
        colors.text.textOnBrand,
        paidBy,
        amountSplit,
        splitType,
        total,
        currency,
        users,
        onSave,
        isDefaultSplit,
    ]);
    return (!!users.length && (<SettingsSection name={showTitle ? 'Split between' : undefined} style={style}>
        <FlatList data={users} scrollEnabled={false} renderItem={renderItem} ListHeaderComponent={ListHeaderComponent} ListFooterComponent={ListFooterComponent} keyExtractor={keyExtractor}/>
      </SettingsSection>));
};
const styles = StyleSheet.create({
    button: {
        marginHorizontal: rem(16),
        marginBottom: rem(16),
        marginTop: rem(8),
    },
    leftIcon: {
        paddingRight: rem(8),
    },
});
export default GroupTransactionSplit;
